// extracted by mini-css-extract-plugin
export default {"transactionHistory":"Transactions_transactionHistory__E4P7T"};